import "./CSS/basis.css";

import {
    BrowserRouter,
    Routes,
    Route
} from "react-router-dom";

import Header from "./components/Header";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";

import NewsPage from "./pages/NewsPage";
import NewsDetailPage from "./pages/NewsDetailPage";
import UeberPage from "./pages/UeberPage";
import WeiterbildungPage from "./pages/WeiterbildungPage";
import WerdegangPage from "./pages/WerdegangPage";
import ZertifikatePage from "./pages/ZertifikatePage";
import DiplomePage from "./pages/DiplomePage";
import HobbysPage from "./pages/HobbysPage";
import FeedbackPage from "./pages/FeedbackPage";
import LinkPage from "./pages/LinkPage";
import ImpressumPage from "./pages/ImpressumPage";
import LoginPage from "./pages/LoginPage";
import AdminPage from "./pages/AdminPage";


function AppContent() {

    return (

        <div
            className="container-index"
            id="top"
        >

            <Header />

            <Navigation />

            <Routes>

                <Route
                    path="/"
                    element={<NewsPage />}
                />

                <Route
                    path="/news/:id"
                    element={<NewsDetailPage />}
                />

                <Route
                    path="/ueber"
                    element={<UeberPage />}
                />

                <Route
                    path="/weiterbildung"
                    element={<WeiterbildungPage />}
                />

                <Route
                    path="/werdegang"
                    element={<WerdegangPage />}
                />

                <Route
                    path="/zertifikate"
                    element={<ZertifikatePage />}
                />

                <Route
                    path="/diplome"
                    element={<DiplomePage />}
                />

                <Route
                    path="/hobbys"
                    element={<HobbysPage />}
                />

                <Route
                    path="/feedback"
                    element={<FeedbackPage />}
                />

                <Route
                    path="/links"
                    element={<LinkPage />}
                />

                <Route
                    path="/impressum"
                    element={<ImpressumPage />}
                />

                <Route
                    path="/login"
                    element={<LoginPage />}
                />

                <Route
                    path="/admin"
                    element={<AdminPage />}
                />

            </Routes>

            <Footer />

        </div>

    );
}


function App() {

    return (

        <BrowserRouter>

            <AppContent />

        </BrowserRouter>

    );
}


export default App;